import AgentsPerformanceProfil from '../../../features/supervision/agentsPerformance/components/AgentsPerformanceProfil/AgentsPerformanceProfil';
import { PageTable, Header } from '/src/layouts/page';
import { useParams } from "react-router-dom";

function AgentsPerformancePage() {
    const params = useParams();
    return (
        <PageTable>

            <>
                <Header title={<span>{"Agent Performance"}</span>}></Header>
                <AgentsPerformanceProfil />
            </>


        </PageTable>
    );
}

export default AgentsPerformancePage;